function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownloadPopupWin = function SvgDownloadPopupWin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 236 125",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEEF1"
    },
    d: "M6,0h224c3.314,0,6,2.686,6,6v113c0,3.314-2.686,6-6,6H6c-3.314,0-6-2.686-6-6V6C0,2.686,2.686,0,6,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F9FF4"
    },
    d: "M0,6c0-3.314,2.686-6,6-6h224c3.314,0,6,2.686,6,6v10H0V6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M226.636,8l1.923-2.003l0.397-0.413c0.058-0.061,0.058-0.16,0-0.221l-0.424-0.442 c-0.059-0.061-0.154-0.061-0.212,0L226,7.337l-2.32-2.416c-0.058-0.061-0.153-0.061-0.212,0l-0.424,0.442 c-0.059,0.061-0.059,0.16,0,0.221L225.364,8l-2.32,2.416c-0.059,0.061-0.059,0.16,0,0.221l0.424,0.442 c0.059,0.061,0.154,0.061,0.212,0L226,8.663l1.923,2.003l0.397,0.413c0.058,0.061,0.153,0.061,0.212,0l0.424-0.442 c0.058-0.061,0.058-0.16,0-0.221L226.636,8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8BCCE"
    },
    d: "M180,91h32c1.105,0,2,0.895,2,2v17c0,1.105-0.895,2-2,2h-32c-1.105,0-2-0.895-2-2V93 C178,91.895,178.895,91,180,91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F9FF4"
    },
    d: "M135,91h32c1.105,0,2,0.895,2,2v17c0,1.105-0.895,2-2,2h-32c-1.105,0-2-0.895-2-2V93 C133,91.895,133.895,91,135,91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M155.918,97.282l-7.193,7.193l-2.643-2.643c-0.128-0.128-0.336-0.128-0.464,0l-0.773,0.774 c-0.128,0.128-0.128,0.335,0,0.464l3.648,3.648c0.128,0.128,0.336,0.128,0.464,0l8.198-8.198c0.128-0.128,0.128-0.336,0-0.464 l-0.773-0.774C156.254,97.154,156.046,97.154,155.918,97.282L155.918,97.282z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 33,
    style: {
      fill: "#BBC8D1"
    },
    width: 191,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 50,
    style: {
      fill: "#BBC8D1"
    },
    width: 173,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBC8D1"
    },
    d: "M23,67h191v7H23V67z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadPopupWin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/downloadPopupWin.0e30ed23.svg";
export { ForwardRef as ReactComponent };